import { Component, Input } from '@angular/core';
import { BuilderLeftEnum } from '#common/enums/builder-left.enum';
import { encodeFilePath } from '#common/functions/encode-file-path';
import { spaceUnitToChartUnit } from '#common/functions/space/space-unit-to-chart-unit';
import type { ChartUnit } from '#common/zod/backend/chart-unit';
import type { SpaceUnit } from '#common/zod/backend/space-unit';
import { NavQuery } from '#front/app/queries/nav.query';
import { UiQuery } from '#front/app/queries/ui.query';
import { ApiService } from '#front/app/services/api.service';
import { MyDialogService } from '#front/app/services/my-dialog.service';
import { NavigateService } from '#front/app/services/navigate.service';

@Component({
  standalone: false,
  selector: 'm-chart-options',
  templateUrl: './chart-options.component.html'
})
export class ChartOptionsComponent {
  @Input()
  set chart(chart: ChartUnit) {
    this.currentChartUnit = chart;
  }

  @Input()
  set spaceUnit(spaceUnit: SpaceUnit) {
    this.currentChartUnit = spaceUnitToChartUnit({ spaceUnit: spaceUnit });
  }

  @Input()
  isHoverM: boolean;

  currentChartUnit: ChartUnit;

  constructor(
    private myDialogService: MyDialogService,
    private apiService: ApiService,
    private navigateService: NavigateService,
    private navQuery: NavQuery,
    private uiQuery: UiQuery
  ) {}

  clickMenu(event: MouseEvent) {
    event.stopPropagation();
  }

  goToFile(event: MouseEvent) {
    event.stopPropagation();

    let fileIdAr = this.currentChartUnit.filePath.split('/');
    fileIdAr.shift();

    let filePath = fileIdAr.join('/');

    this.uiQuery.updatePart({ secondFileNodeId: undefined });

    this.navigateService.navigateToFileLine({
      builderLeft: BuilderLeftEnum.Tree,
      encodedFileId: encodeFilePath({ filePath: filePath })
    });
  }

  async editChartInfo(event: MouseEvent, item: ChartUnit) {
    event.stopPropagation();

    if (item.canEditOrDeleteChart === false) {
      return;
    }

    let nav = this.navQuery.getValue();

    this.myDialogService.showEditChartInfo({
      apiService: this.apiService,
      projectId: nav.projectId,
      branchId: nav.branchId,
      envId: nav.envId,
      repoId: nav.repoId,
      repoType: nav.repoType,
      chart: item
    });
  }

  deleteChart(event: MouseEvent, item: ChartUnit) {
    event.stopPropagation();

    let nav = this.navQuery.getValue();

    this.myDialogService.showDeleteChart({
      chart: item,
      apiService: this.apiService,
      projectId: nav.projectId,
      branchId: nav.branchId,
      envId: nav.envId,
      repoId: nav.repoId,
      repoType: nav.repoType
    });
  }
}
